import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { THEME_ID, ThemeProvider, createTheme } from '@mui/material/styles';
import { SpeedInsights } from "@vercel/speed-insights/react";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

const materialTheme = createTheme();
root.render(
	<ThemeProvider theme={{ [THEME_ID]: materialTheme }}>
		<React.StrictMode>
			<App />
			<SpeedInsights />
		</React.StrictMode>
	</ThemeProvider>
);
